
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 402.779 402.779","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M55.734 217.682H271.48c9.007 0 16.328-7.326 16.328-16.317 0-9.007-7.321-16.328-16.328-16.328H55.74l31.46-31.449c6.337-6.364 6.337-16.709-.033-23.105-3.089-3.062-7.18-4.754-11.531-4.754s-8.447 1.692-11.542 4.775L4.879 189.725c-1.539 1.507-2.763 3.301-3.677 5.493A16.51 16.51 0 000 201.36c0 2.099.402 4.172 1.246 6.239.843 2.061 2.072 3.873 3.535 5.298l59.302 59.318c3.079 3.089 7.18 4.781 11.542 4.781 4.351 0 8.452-1.697 11.563-4.792 6.32-6.353 6.331-16.693-.016-23.083z"}}),_c('path',{attrs:{"d":"M348.388 55.239H164.874c-29.986 0-54.38 24.405-54.38 54.396l.022 48.332c.201 8.79 7.511 15.947 16.301 15.947 5.336 0 10.117-2.633 13.103-6.663l3.22-.049V109.64c0-11.993 9.752-21.751 21.734-21.751h183.514c11.982 0 21.74 9.758 21.74 21.751v183.503c0 11.993-9.758 21.751-21.74 21.751H164.874c-11.982 0-21.734-9.758-21.734-21.751l-.038-57.714h-3.182c-2.953-4.003-7.702-6.57-13.103-6.57-8.887 0-16.051 6.984-16.323 16.328v47.956c0 29.991 24.394 54.396 54.38 54.396h183.514c29.991 0 54.391-24.405 54.391-54.396V109.641c0-29.997-24.4-54.402-54.391-54.402z"}})])
          )
        }
      }
    